import { fork } from "redux-saga/effects";
import * as watchers from "./watcher";

export default function* startForman() {
  yield fork(watchers.watchUserAuthentication);
  yield fork(watchers.watchAuthyAuthentication);
  yield fork(watchers.watchJwt);
  yield fork(watchers.watchAccount);
  yield fork(watchers.watchAccountUser);
  yield fork(watchers.watchAnalysis);
  yield fork(watchers.watchUser);
  yield fork(watchers.watchTeam);
  yield fork(watchers.watchTeamUser);
  yield fork(watchers.watchRole);
  yield fork(watchers.watchPermission);
  yield fork(watchers.watchRolePermission);
  yield fork(watchers.watchConfig);
  yield fork(watchers.watchConfigDefault);
  yield fork(watchers.watchExternalLink);
  yield fork(watchers.watchAboutMicroservice);
  yield fork(watchers.watchAlert);
  yield fork(watchers.watchGlobalMessage);
  yield fork(watchers.watchKibana);
  yield fork(watchers.watchLogstash);

  /* Yardsight-specific Watcher */
  yield fork(watchers.watchYms);
}
